import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationAR from './locales/ar/translation.json';
import translationEN from './locales/en/translation.json';

const resources = {
    ar: { translation: translationAR },
    en: { translation: translationEN },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'ar',
        lng: localStorage.getItem('i18nextLng') || 'ar',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'cookie'],
            caches: ['localStorage'],
        },
        react: {
            useSuspense: false,
        },
        supportedLngs: ['ar', 'en'],
        nonExplicitSupportedLngs: true,
    });

export default i18n;